import moreRequestData from './moreRequestData';
import myCarsData from './myCarsData';

const root = {
	moreRequestData,
	myCarsData
};

export default root;
